import React from 'react';
import { MuiBox, Box, Backdrop, SvgIconButton, Logo, ContainerBox, Grid, SvgIcon } from '@kis-technologies/kis-ui';
import { selectors as adminsSelectors, actions as adminsActions } from 'store/admins';
import { useSelector } from 'react-redux';
import { CreateNewUserOverlayProps } from '../types';
import { CreateNewUserForm } from './CreateNewUserForm';
import { CreateNewUserSuccess } from './CreateNewUserSuccess';
import { useActions } from 'hooks/useActions';
import { useStyles } from '../styled';

export const CreateNewUserOverlay = (props: CreateNewUserOverlayProps) => {
  const { onCancel, onConfirm } = props;

  // ACTION CREATORS AND SELECTORS
  const { resetAction } = useActions({
    resetAction: adminsActions.resetAction
  });
  const { successful } = useSelector(adminsSelectors.selectAction);
  const classes = useStyles();

  // CANCEL CLICK
  const onCancelClick = () => {
    // IF ACTION SUCCESSFUL - RESET ACTION
    if (successful) resetAction();
    // PROPS.ONCANCEL
    onCancel();
  };

  return (
    <Backdrop open>
      <Box bg="x-light-gray" height="100vh" width="100%" overflow="auto">
        <ContainerBox className={classes.createNewUserContainer}>
          <Box bg="white" sx={{ borderRadius: '32px 32px 0 0' }}>
            {/* OVERLAY HEADER */}
            <Grid className={classes.createNewUserLogoBlock}>
              <MuiBox className={classes.createNewUserLogo}>
                <Logo />
              </MuiBox>
              <MuiBox className={classes.createNewUserCloseIcon}>
                <SvgIconButton data-testid="create-new-user-x" onClick={onCancelClick} appearance="transparent">
                  <SvgIcon name="exit_circle" size={40} />
                </SvgIconButton>
              </MuiBox>
            </Grid>
            {/* IF ACTION SUCCESSFUL - SHOW CREATENEWUSERSUCCESS COMPONENT ELSE SHOW CREATENEWUSERFORM COMPONENT */}
            {successful ? <CreateNewUserSuccess onConfirm={onConfirm} /> : <CreateNewUserForm />}
          </Box>
        </ContainerBox>
      </Box>
    </Backdrop>
  );
};
